export const GetSettings = async (token, propertyKey) => {
  const response = await fetch(`/GetSettingsByKey?key=${propertyKey}`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });

  const result = response.json();
  return result;
};
